import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class MassWhatsAppAPI {

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(`${Config.app.link}api/mass-whatsapp/list`, new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(`${Config.app.link}api/mass-whatsapp/${id}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static count = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/mass-whatsapp/list/count', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (call, success, failure) => {
    fetch(Config.app.link + 'api/mass-whatsapp/add-edit', new Header('POST', call))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/mass-whatsapp/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default MassWhatsAppAPI;